import { NgControl } from '@angular/forms';

export const isControlValid = (control: NgControl): boolean => control.valid || !control.touched;
